import { createRoot } from 'react-dom/client'
import { StrictMode } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router'
import { HelmetProvider } from 'react-helmet-async'

import './App.scss'
import Layout from './lib/Layout'
import Home from './views/Home'
import Services from './views/Services'
import About from './views/About'
import Contact from './views/Contact'
import Transport from './views/Transport'
import Team from './views/Team'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
        path: '/',
      },
      {
        element: <Services />,
        path: '/services',
      },
      {
        element: <About />,
        path: '/about-us',
      },
      {
        element: <Contact />,
        path: '/contact-us',
      },
      {
        element: <Team />,
        path: '/team',
      },
    ],
  },
  {
    path: '/transport',
    element: <Transport />,
  },
])

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </StrictMode>,
)
